const Reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_START":
      return {
        user: null,
        isFetching: true,
        error: false,
        userViews: state.userViews,
        token: state.token,
      };
    case "LOGIN_SUCCESS":
      const flattenedUser = action.payload.user
        ? { ...action.payload.user, token: action.payload.token } // Google
        : action.payload; // Email/password

      localStorage.setItem("user", JSON.stringify(flattenedUser));

      return {
        user: flattenedUser,
        isFetching: false,
        error: false,
        userViews: state.userViews,
        token: action.payload.token,
      };
    case "LOGIN_FAILURE":
      return {
        user: null,
        isFetching: false,
        error: true,
        userViews: state.userViews,
        token: null,
      };
    case "UPDATE_START":
      return {
        ...state,
        isFetching: true,
      };
    case "UPDATE_SUCCESS":
      const updatedUser = action.payload.user
        ? { ...action.payload.user, token: state.token } // Google
        : { ...action.payload, token: state.token }; // Email/password

      localStorage.setItem("user", JSON.stringify(updatedUser));

      return {
        user: updatedUser,
        isFetching: false,
        error: false,
        userViews: state.userViews,
        token: state.token,
      };
    case "UPDATE_FAILURE":
      return {
        user: state.user,
        isFetching: false,
        error: true,
        userViews: state.userViews,
        token: state.token,
      };
    case "INCREMENT_USER_VIEWS":
      const { articleId } = action.payload;
      if (state.uniqueArticleIds) {
        if (!state.uniqueArticleIds.has(articleId)) {
          return {
            ...state,
            userViews: state.userViews + 1,
            uniqueArticleIds: new Set([...state.uniqueArticleIds, articleId]),
          };
        }
      }

      return state;
    case "LOGOUT":
      return {
        user: null,
        isFetching: false,
        error: false,
        userViews: state.userViews,
        token: null,
      };
    default:
      return state;
  }
};

export default Reducer;
